import React from 'react';
import { cn } from '@/utils/cn';
import TextBase from '../../Typography/TextBase';
import Icon from '../../Icon';

function SortLabel({ activeItem, formattedName, item }) {
  return (
    <>
      <TextBase
        text={`${item?.name}`}
        className={cn(
          'inline-block text-coarse-wool font-medium tracking-[0.28px] capitalize lg:tracking-[0.32px]',
          {
            '!font-semibold !text-richcarmine':
              activeItem?.name === formattedName,
          },
        )}
      />
      {activeItem?.name === formattedName ? (
        <Icon type="radio-active" className="size-[19px] lg:size-[25px]" />
      ) : (
        <Icon type="radio" className="size-[18px] lg:size-[24px]" />
      )}
    </>
  );
}

export default SortLabel;
